import ReactDOM from 'react-dom';

import { BarChartMetaData } from '../../../../../shared/types/widget';
import { TooltipContentJSX } from './renderTooltip';
import { RefObject } from 'react';

interface BenchmarkTooltipProps {
  tooltip: {
    x: number;
    y: number;
    label: string;
    score: number;
    uniqueRespondents: number;
  };
  tooltipHeight: number;
  tooltipRef: RefObject<HTMLDivElement | null>;
  meta: BarChartMetaData;
  setTooltip: (value: null) => void;
  hoverTimeoutRef: RefObject<NodeJS.Timeout | number | null>;
}

const BenchmarkTooltip = ({
  tooltip,
  tooltipHeight,
  tooltipRef,
  meta,
  setTooltip,
  hoverTimeoutRef,
}: BenchmarkTooltipProps) => {
  const clearHoverTimeout = () => {
    if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
  };

  const setHideTooltipTimeout = () => {
    hoverTimeoutRef.current = setTimeout(() => {
      setTooltip(null);
    }, 100);
  };

  return ReactDOM.createPortal(
    <div
      role="tooltip"
      ref={tooltipRef}
      onFocus={clearHoverTimeout}
      onBlur={setHideTooltipTimeout}
      onMouseEnter={clearHoverTimeout}
      onMouseLeave={setHideTooltipTimeout}
      className="border-black-200 text-black-700 fixed z-50 flex w-50 flex-col rounded-lg border bg-white whitespace-normal shadow-[0px_12px_16px_-4px_#10182814]"
      style={{
        left: tooltip.x,
        top: tooltip.y - tooltipHeight - 28,
        transform: 'translateX(-50%)',
      }}
    >
      <TooltipContentJSX
        meta={meta}
        score={tooltip.score}
        uniqueRespondents={tooltip.uniqueRespondents}
        title={tooltip.label}
      />
      <div className="clip-top absolute right-0 -bottom-[7px] left-0 m-auto h-2 w-4 bg-white"></div>
    </div>,
    document.body,
  );
};

export default BenchmarkTooltip;
